/**
 * GET /lessons/user/:userId — the packs the caller holds at the request's
 * club, newest first, every status. Self-only: the server 403s any other id.
 *
 * Thin pass-through: returns the envelope unchanged
 * (docs/conventions/internalapi-envelope.md). Tenant and club headers come
 * from `appRuntime` via apiClient.
 */

import { apiClient } from '~/lib/apiClient';
import type { ApiResult } from '~/lib/apiClient/types';
import type { GetUserLessonsPayload } from '../types';

export function getUserLessons(
  userId: number,
  ctx: { clubId: number },
): Promise<ApiResult<GetUserLessonsPayload>> {
  if (!ctx.clubId) throw new Error('clubId is required');
  return apiClient.get<GetUserLessonsPayload>(`/lessons/user/${userId}`);
}
